// Allow deferred pattern with ES6 promises...

export default class Deferred<T> {
  promise: Promise<T>;

  resolve: (value: T | PromiseLike<T>) => void;

  reject: (reason?: any) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    Object.freeze(this);
  }
}
